import React from 'react'
import {Icon} from '@chakra-ui/react'

const CarouselPrevIcon = (props) => (
    <Icon viewBox="0 0 16 16" boxSize="16px" fill="none" {...props}>
        <path
            d="M9 4L5 8L9 12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
)

export default CarouselPrevIcon
